export default "__VITE_ASSET__DSU2yGU0__"